import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconStageSucceed = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 80,
	height: 80,
	viewBox: "0 0 80 80",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M61.2294 47.3679L69.5707 61.8133C69.9387 62.4479 69.6454 62.8799 68.9227 62.7466L59.968 61.2319L56.864 69.7653C56.6134 70.4533 56.1014 70.5013 55.728 69.8719L47.728 56.3439",
			stroke: "black",
			strokeWidth: 2.70833,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.7707 47.3679L10.4294 61.8133C10.0614 62.4479 10.3547 62.8799 11.0774 62.7466L20.032 61.2319L23.1387 69.7653C23.3894 70.4559 23.9014 70.5013 24.2747 69.8719L32.2747 56.3599",
			stroke: "black",
			strokeWidth: 2.70833,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M61.3334 31.0187C61.3338 29.5324 60.8879 28.0802 60.0535 26.8502C59.2191 25.6202 58.0346 24.6691 56.6534 24.12C57.2409 22.7553 57.4055 21.2456 57.1257 19.7864C56.8459 18.3271 56.1347 16.9853 55.0841 15.9347C54.0334 14.884 52.6916 14.1728 51.2324 13.893C49.7731 13.6132 48.2634 13.7778 46.8987 14.3654C46.3491 12.985 45.3979 11.8014 44.1683 10.9674C42.9387 10.1335 41.4871 9.68774 40.0014 9.68774C38.5156 9.68774 37.0641 10.1335 35.8344 10.9674C34.6048 11.8014 33.6536 12.985 33.104 14.3654C31.7389 13.7753 30.2281 13.6088 28.7673 13.8875C27.3064 14.1662 25.963 14.8771 24.911 15.9283C23.859 16.9794 23.1469 18.3223 22.867 19.7829C22.5872 21.2435 22.7524 22.7545 23.3414 24.12C21.96 24.6686 20.7751 25.6194 19.9403 26.8492C19.1055 28.0789 18.6592 29.531 18.6592 31.0174C18.6592 32.5037 19.1055 33.9558 19.9403 35.1856C20.7751 36.4153 21.96 37.3661 23.3414 37.9147C22.7538 39.2794 22.5892 40.7891 22.869 42.2484C23.1488 43.7077 23.86 45.0494 24.9107 46.1001C25.9613 47.1507 27.3031 47.862 28.7623 48.1417C30.2216 48.4215 31.7313 48.257 33.096 47.6694C33.6446 49.0508 34.5954 50.2356 35.8251 51.0704C37.0549 51.9052 38.507 52.3516 39.9934 52.3516C41.4797 52.3516 42.9318 51.9052 44.1616 51.0704C45.3913 50.2356 46.3421 49.0508 46.8907 47.6694C48.2554 48.257 49.7651 48.4215 51.2244 48.1417C52.6836 47.862 54.0254 47.1507 55.0761 46.1001C56.1267 45.0494 56.8379 43.7077 57.1177 42.2484C57.3975 40.7891 57.2329 39.2794 56.6454 37.9147C58.0281 37.3677 59.2144 36.4177 60.0504 35.188C60.8863 33.9583 61.3334 32.5057 61.3334 31.0187V31.0187Z",
			stroke: "black",
			strokeWidth: 2.70833,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M50.6667 24.3521L38.0827 36.9387C37.897 37.1246 37.6765 37.272 37.4337 37.3726C37.191 37.4732 36.9308 37.525 36.6681 37.525C36.4053 37.525 36.1452 37.4732 35.9024 37.3726C35.6597 37.272 35.4391 37.1246 35.2534 36.9387L30.6667 32.3521",
			stroke: "black",
			strokeWidth: 2.70833,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgIconStageSucceed;
